import React from "react";

import SwapHoriz from "@mui/icons-material/SwapHoriz";

export default function ChangeStatusAction({ text }) {
  return (
    <>
      <SwapHoriz
        style={{ color: "rgba(33, 43, 54, 0.9)", marginRight: 8 }}
        fontSize="0.9rem"
      />
      <span
        style={{
          color: "rgba(33, 43, 54, 0.9)",
          fontSize: "0.9rem",
          fontFamily: "SeagoeUIBold",
        }}
      >
        {text}
      </span>
    </>
  );
}
